import React from 'react';
import CashierWidget from '../CashierWidget';
import ModalLayout from '../ModalLayout';
import BasicModalLayoutFooter from '../ModalLayout/BasicModalLayoutFooter';
import { Modal } from 'wix-style-react';

export default function CashierWidgetModal({ isOpen, addCashierPayment, isCashierInitializing, ...rest }) {
  const footer = (
    <BasicModalLayoutFooter
      onCancelClick={rest.onRequestClose}
      onOkClick={() => {
        addCashierPayment({ paymentMethod: rest.singlePaymentMethod });
      }}
      okLoading={isCashierInitializing}
    />
  );

  return (
    <Modal isOpen={isOpen} onRequestClose={rest.onRequestClose} shouldCloseOnOverlayClick>
      {isOpen && (
        <ModalLayout title="Payment" onCloseClick={rest.onRequestClose} footer={footer}>
          <CashierWidget {...rest} />
        </ModalLayout>
      )}
    </Modal>
  );
}

CashierWidgetModal.displayName = 'CashierWidgetModal';
